
export default class CouponController {
    constructor(resource) {
        this._resource = resource
    }

    async report() {
        let response = null
        try {
            let result = await this._resource(`transactions/report`).get()

            return result
        } catch (error) {
            throw error
        }
    }

    async get() {
        return await this._resource(`coupons`).get()
            .then(res => res.body)
    }

    async validateCoupon(cupomInfos) {
        try {
            
            const response = await this._resource(`validade-coupon-by-adm`).save(cupomInfos);
            
            return response;
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
    }

    async getByCode(code) {
        return this._resource(`coupons/name/${code}`).get(code)
            .then(res => {
                return res.body
            }, err => {
                throw new Error(err)
            });
    }

    async delete(id) {
        return await this._resource(`coupon/${id}`).delete(id)
            .then(res => res.body)
    }

    async update(coupon) {
        return await this._resource(`coupon`).update(coupon)
            .then(res => res.body)
    }

    async create(coupon) {
        return await this._resource(`coupon`).save(coupon)
            .then(res => res.body)
    }
}